import { render, staticRenderFns } from "./video_input.vue?vue&type=template&id=2149cfb6&scoped=true&"
import script from "./video_input.vue?vue&type=script&lang=js&"
export * from "./video_input.vue?vue&type=script&lang=js&"
import style0 from "./video_input.vue?vue&type=style&index=0&id=2149cfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2149cfb6",
  null
  
)

export default component.exports